/*
 * @Author: wangxinbin88 528350580@qq.com
 * @Date: 2025-01-08 10:29:50
 * @LastEditors: wangxinbin88 528350580@qq.com
 * @LastEditTime: 2025-02-06 16:44:25
 * @FilePath: \virtual-power-plant-ui\src\store\modules\user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  login,
  logout,
  getInfo
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  isHttp,
  isEmpty
} from "@/utils/validate"
import defAva from '@/assets/images/profile.jpg'
import useWebSocketStore from '@/store/modules/socket';
import { encrypt } from "@/utils/jsencrypt"
const useUserStore = defineStore(
  'user', {
    state: () => ({
      token: getToken(),
      id: '',
      name: '',
      nickName: '',
      avatar: '',
      roles: [],
      permissions: [],
      wsInitialized: false,
      homePage: '', 
      isAdmin: false,
    }),
    actions: {

      // 登录
      login(userInfo) {
        const username = userInfo.username.trim()
        // const password = encrypt(userInfo.password)
        const password = userInfo.password
        const code = userInfo.code
        const uuid = userInfo.uuid
        return new Promise((resolve, reject) => {
          login(username, password, code, uuid).then(res => {
            this.homePage = res.homePage;
            setToken(res.token)
            this.token = res.token;
            // 生成一个随机Id，最大三位数，不同浏览器生成不同Id
            // if (!this.wsInitialized) { 
            //   const randomId = Math.floor(Math.random() * 1000).toString();
            //   const wsStore = useWebSocketStore();
            //   wsStore.initWebSocket(randomId);
            //   this.wsInitialized = true;
            // }
        
            resolve(res)

          }).catch(error => {
            reject(error)
          })
        })
      },

      // 获取用户信息
      getInfo() {
        return new Promise((resolve, reject) => {
          getInfo().then(res => {
            const user = res.user
            let avatar = user.avatar || ""
            if (!isHttp(avatar)) {
              avatar = (isEmpty(avatar)) ? defAva : import.meta.env.VITE_APP_BASE_API + avatar
            }
            if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
              this.roles = res.roles
              this.permissions = res.permissions
            } else {
              this.roles = ['ROLE_DEFAULT']
            }
            this.id = user.userId
            this.name = user.userName
            this.nickName = user.nickName
            this.avatar = avatar
            this.homePage = user.roles[0]?.homePage;
            if (!this.wsInitialized) { 
              const randomId = Math.floor(Math.random() * 1000).toString();
              // const wsStore = useWebSocketStore();
              // wsStore.initWebSocket(randomId);
              this.wsInitialized = true;
            }
            this.isAdmin = res.isAdmin;
            resolve(res);

          }).catch(error => {
            reject(error)
          })
        })
      },
      // 退出系统
      logOut() {
        return new Promise((resolve, reject) => {
          logout(this.token).then(() => {
            // const wsStore = useWebSocketStore()
            // wsStore.closeWebSocket()
            this.wsInitialized = false
            this.token = ''
            this.roles = []
            this.permissions = []
            
            sessionStorage.clear()
            localStorage.clear();
            removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      }
    }
  })

export default useUserStore